import { useDispatch } from "react-redux";
import {
  connectToSocial,
  disconnectImport,
  getSummary,
  googleLatestContactSync,
  importCSV,
  outlookLatestContactSync,
} from "../../../actionCreator/importActionCreator";
import { useAlert } from "../../../context/AlertProvider";

import { Modal } from "antd";

export const useImport = () => {
  const dispatch = useDispatch();
  const { showAlert } = useAlert();

  const handleCSVImport = async (payload, callback) => {
    const res = await dispatch(importCSV(payload));

    if (res.status === 200) {
      if (res?.data?.errors?.length) {
        const sortedErrors = [...res.data.errors].sort(
          (a, b) => a.rowNumber - b.rowNumber,
        );

        Modal.warning({
          title: "Import Completed with Warnings",
          content: (
            <div className="tw-mt-4">
              <div className="tw-text-sm tw-text-sub-text tw-mb-4">
                We successfully imported most of your leads. However,{" "}
                <span className="tw-font-semibold tw-text-black">
                  {sortedErrors.length}
                </span>{" "}
                rows had validation errors and were skipped.
              </div>
              <div className="tw-rounded-lg tw-border tw-border-solid tw-border-border-secondary tw-overflow-hidden">
                <div
                  className="tw-overflow-y-auto custom-scrollbar tw-bg-gray-50"
                  style={{ maxHeight: "300px" }}
                >
                  {sortedErrors.map((d, i) => (
                    <div
                      key={i}
                      className={`tw-text-sm tw-px-4 tw-py-3 ${
                        i !== sortedErrors.length - 1
                          ? "tw-border-b tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-solid tw-border-border-secondary"
                          : ""
                      }`}
                    >
                      <span className="tw-font-medium tw-text-red-500">
                        Row {d?.rowNumber}:
                      </span>{" "}
                      <span className="tw-text-sub-text tw-ml-1">
                        {d?.detail}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ),
          width: 500,
          okText: "Got it",
          okButtonProps: {
            className: "!tw-bg-theme !tw-border-theme !tw-shadow-none",
          },
        });
      } else {
        showAlert("success", "All leads imported successfully.");
      }
      callback();
      dispatch(getSummary());
    } else {
      showAlert("error", res?.response?.data?.detail);
    }
  };

  const handleConnect = async (type) => {
    localStorage.setItem('oauth_return_to', window.location.pathname);
    const res = await dispatch(connectToSocial(type));
    if (res?.status === 200) {
      window.open(res?.data?.url, "_self");
    } else {
      showAlert("error", `Something went wrong. Please try again.`);
    }
  };

  const handleDisconnect = async (type) => {
    const res = await dispatch(disconnectImport(type));

    if (res?.status === 200) {
      let message;

      switch (type) {
        case "Gmail":
          message = "Gmail disconnected successfully.";
          break;
        case "CSV":
          message = "CSV removed successfully.";
          break;
        case "Beyondleadz data":
          message = "Beyondleadz data disconnected successfully.";
          break;
        case "Outlook":
          message = "Outlook disconnected successfully.";
          break;
        default:
          message = `${type} disconnected successfully.`;
      }

      showAlert("success", message);
      dispatch(getSummary());
    } else {
      showAlert("error", "Something went wrong. Please try again.");
    }
  };

  const handleLatestSync = async (type) => {
    let res;
    switch (type) {
      case "Gmail":
        res = await dispatch(googleLatestContactSync());
        break;
      case "Outlook":
        res = await dispatch(outlookLatestContactSync());
        break;
      default:
        break;
    }

    if (res?.status === 200) {
      showAlert("success", "Contacts synced successfully.");
    } else {
      showAlert("error", "Something went wrong. Please try again.");
    }
  };

  return {
    handleCSVImport,
    handleConnect,
    handleDisconnect,
    handleLatestSync,
  };
};
